import * as React from 'react';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { Messages } from '../../../../codegen/Localize';
import { CommonStyles } from '../../../../common/react/CommonStyles';
import { cssClass } from '../../../../style';


const rowHeight = '39px';
const cssPrefix = 'DataroleValuesAndSynonymsHeader';
const headerStyle =  cssClass(cssPrefix, 'header', {
  borderBottom: '1px solid rgb(235, 235, 235)',
  height: rowHeight,
  lineHeight: rowHeight,
  color: '#333',
  fontSize: '13px',
});

const cellStyle =  cssClass(cssPrefix, 'value', {
  paddingLeft: CommonStyles.Sizes.MediumSpace,
  display: 'inline-block',
  boxSizing: 'border-box',
  cursor: 'pointer',
  fontWeight: 'bold',
  $nest: {
    '&:hover': {
      backgroundColor: '#F5F5F5',
      textDecoration: 'underline',
    },
  }
});

export const ValuesAndSynonymsHeader = () => (
  <div className={headerStyle}>
    <div className={cellStyle} style={{width: '33%'}}>{Messages.dataRoleDefinitionSubspace_Values_Name()}</div>
    <div className={cellStyle} style={{width: '67%'}}>{Messages.dataRoleDefinitionSubspace_Values_Synonyms()}</div>
  </div>);
